export default __webpack_public_path__ + "static/4-5fa569db471537d70f649dcaacedcca1.png";